import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77e44447"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-header" }
const _hoisted_2 = {
  ref: "searchHeader",
  class: "search-header-inner bg-white"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-header-notch" }, null, -1))
const _hoisted_4 = { class: "search-header-items" }
const _hoisted_5 = { class: "w-100 container pull-to-refresh-ios" }
const _hoisted_6 = { class: "infinite-loading-container" }
const _hoisted_7 = {
  key: 0,
  class: "p-3 bg-white text-14 text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "p-3 bg-white text-14 text-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppStoreBanner = _resolveComponent("AppStoreBanner")!
  const _component_OrderTab = _resolveComponent("OrderTab")!
  const _component_DesiredWorkScheduleButton = _resolveComponent("DesiredWorkScheduleButton")!
  const _component_FilterButton = _resolveComponent("FilterButton")!
  const _component_DistanceSortButton = _resolveComponent("DistanceSortButton")!
  const _component_OrderDatePicker = _resolveComponent("OrderDatePicker")!
  const _component_BToaster = _resolveComponent("BToaster")!
  const _component_Ad = _resolveComponent("Ad")!
  const _component_TooltipHighlightText = _resolveComponent("TooltipHighlightText")!
  const _component_TooltipPopup = _resolveComponent("TooltipPopup")!
  const _component_OrderCardSimple = _resolveComponent("OrderCardSimple")!
  const _component_PullToRefresh = _resolveComponent("PullToRefresh")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BModal = _resolveComponent("BModal")!
  const _component_FirstBootSurveyModal = _resolveComponent("FirstBootSurveyModal")!
  const _component_JobChangeModal = _resolveComponent("JobChangeModal")!
  const _component_ApplicationReminderModal = _resolveComponent("ApplicationReminderModal")!
  const _component_AppSatisfactionModal = _resolveComponent("AppSatisfactionModal")!
  const _component_WorkerServiceReSettingModal = _resolveComponent("WorkerServiceReSettingModal")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppStoreBanner, {
      shouldShown: _ctx.shouldShownAppStoreBanner,
      onClose: _ctx.closeAppStoreBanner
    }, null, 8, ["shouldShown", "onClose"]),
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass(["search-page", _ctx.shouldShownAppStoreBanner ? 'app-store-banner-space' : null])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(),
          _createVNode(_component_OrderTab, {
            orderType: _ctx.orderType,
            existsLimitedOrder: _ctx.existsLimitedOrders,
            existsIndividualOrder: _ctx.existsIndividualOrders
          }, null, 8, ["orderType", "existsLimitedOrder", "existsIndividualOrder"]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isLogin)
              ? (_openBlock(), _createBlock(_component_DesiredWorkScheduleButton, {
                  key: 0,
                  class: "schedule-button"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _createVNode(_component_FilterButton, {
              id: "tooltippopup-to-filter-button",
              class: "mr-3",
              filterCount: _ctx.filterCount,
              onClickFilter: _cache[0] || (_cache[0] = ($event: any) => (
                _ctx.$router.push({
                  name: 'SearchCondition',
                  query: { orderType: _ctx.orderType }
                })
              ))
            }, null, 8, ["filterCount"]),
            _createTextVNode(),
            _createVNode(_component_DistanceSortButton, {
              isSortApplied: _ctx.isDistanceSortApplied,
              onClickSort: _ctx.toggleDistanceSortKey
            }, null, 8, ["isSortApplied", "onClickSort"])
          ]),
          _createTextVNode(),
          _createVNode(_component_OrderDatePicker, {
            dateList: _ctx.dateList,
            selectedDate: _ctx.selectedDate,
            onSelect: _ctx.setSelectedDate
          }, null, 8, ["dateList", "selectedDate", "onSelect"])
        ], 512)
      ]),
      _createTextVNode(),
      _createVNode(_component_BToaster, {
        name: "search-toaster-top",
        class: "search-toaster position-fixed"
      }),
      _createTextVNode(),
      _createVNode(_component_Ad, {
        adSlot: "search_public_order",
        class: "ad-slot-search"
      }),
      _createTextVNode(),
      _createVNode(_component_Ad, { adSlot: "modal" }),
      _createTextVNode(),
      _createVNode(_component_TooltipPopup, {
        position: "bottom",
        targetSelector: "#tooltippopup-to-filter-button"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createTextVNode("\n          お仕事探すなら"),
            _createVNode(_component_TooltipHighlightText, null, {
              default: _withCtx(() => [
                _createTextVNode("絞り込み")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode("が便利！\n        ")
          ])
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(_component_PullToRefresh, {
          onPull: _ctx.reloadOrder,
          isShowingPullToRefreshLoading: _ctx.isShowingPullToRefreshLoading
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderList, (order, index) => {
              return (_openBlock(), _createBlock(_component_OrderCardSimple, {
                key: 'orderList/' + index,
                order: order,
                isLogin: _ctx.isLogin,
                isRegisteredWatchLater: _ctx.isRegisteredWatchLater(order),
                id: _ctx.createOrderIdForElement((order || {}).id),
                class: "my-2 mx-2",
                evaluation: _ctx.getEvaluation(order),
                onCardClick: _ctx.onCardClick,
                onChangeWatchLater: ($event: any) => (_ctx.onWatchLaterChange(order))
              }, null, 8, ["order", "isLogin", "isRegisteredWatchLater", "id", "evaluation", "onCardClick", "onChangeWatchLater"]))
            }), 128)),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.orderList.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, "\n              ここが最後です\n            "))
                : _createCommentVNode("", true),
              _createTextVNode(),
              (_ctx.orderList.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "\n              条件に一致する仕事はありません\n            "))
                : _createCommentVNode("", true)
            ])
          ], undefined, true),
          _: 1
        }, 8, ["onPull", "isShowingPullToRefreshLoading"])
      ])), [
        [
          _directive_touch,
          _ctx.swipeLeftHandler,
          "swipe",
          { left: true }
        ],
        [
          _directive_touch,
          _ctx.swipeRightHandler,
          "swipe",
          { right: true }
        ]
      ]),
      _createTextVNode(),
      _createVNode(_component_AppFooter),
      _createTextVNode(),
      _createVNode(_component_BlockBack),
      _createTextVNode(),
      _createVNode(_component_BModal, {
        modelValue: _ctx.needsGPSModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.needsGPSModal) = $event)),
        title: "位置情報について",
        centered: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n          最寄りのお仕事を表示するため、端末の位置情報を使用します。\n          お使いの端末の設定から権限を許可してください。"),
          _hoisted_9,
          _hoisted_10,
          _createTextVNode("\n          なお、絞込機能で表示するお仕事を絞り込みすることも可能です。\n        ")
        ]),
        "modal-footer": _withCtx(({ ok }) => [
          _createVNode(_component_BButton, {
            size: "sm",
            variant: "text",
            onClick: ok
          }, {
            default: _withCtx(() => [
              _createTextVNode(" OK ")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"]),
          _createTextVNode(),
          (_ctx.isCordova)
            ? (_openBlock(), _createBlock(_component_BButton, {
                key: 0,
                size: "sm",
                variant: "secondary",
                onClick: _ctx.openSetting
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            設定を開く\n          ")
                ], undefined, true),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(),
      _createVNode(_component_FirstBootSurveyModal, {
        show: _ctx.showFirstBootSurvey,
        onClose: _ctx.onFirstBootSurveyRegistered
      }, null, 8, ["show", "onClose"]),
      _createTextVNode(),
      (_ctx.shouldAskJobChange)
        ? (_openBlock(), _createBlock(_component_JobChangeModal, { key: 0 }))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createVNode(_component_ApplicationReminderModal, {
        applicationToRemind: _ctx.applicationToRemind,
        onCloseHook: _ctx.closeHookApplicationReminderModal
      }, null, 8, ["applicationToRemind", "onCloseHook"])
    ], 2),
    _createTextVNode(),
    _createVNode(_component_AppSatisfactionModal, {
      id: "app-review-modal",
      shouldShow: _ctx.shouldShowAppSatisfactionModal,
      answeredTiming: _ctx.answeredTiming,
      onClose: _ctx.closeAppReviewModal
    }, null, 8, ["shouldShow", "answeredTiming", "onClose"]),
    _createTextVNode(),
    _createVNode(_component_WorkerServiceReSettingModal, {
      show: _ctx.needsWorkerServiceReSettingModal,
      onSubmit: _ctx.submitWorkerServiceReSetting
    }, null, 8, ["show", "onSubmit"])
  ]))
}